// document.addEventListener('contextmenu', function(e) {
//     e.preventDefault();
// });

// document.addEventListener('copy', function(e) {
//     e.preventDefault();
// });

// document.addEventListener('keydown', function(e) {
//     if (e.keyCode == 123 || 
//         (e.ctrlKey && e.shiftKey && e.keyCode == 73) || 
//         (e.ctrlKey && e.shiftKey && e.keyCode == 74) || 
//         (e.ctrlKey && e.keyCode == 85)) {
//         e.preventDefault();
//     }
// });

// document.addEventListener('DOMContentLoaded', function() {
//   function updateVisitorCount() {
//     var min = 5; // Minimum number of visitors
//     var max = 20; // Maximum number of visitors
//     var randomVisitorCount = Math.floor(Math.random() * (max - min + 2)) + min;
//     document.getElementById('visitor-count').textContent = randomVisitorCount;
//   }
//   updateVisitorCount();
//   setInterval(updateVisitorCount, 20000);
// });

document.addEventListener('DOMContentLoaded', function() {

  function updateVisitorCount() {
    var min = 5;
    var max = 20;
    var randomVisitorCount = Math.floor(Math.random() * (max - min + 1)) + min;

    var visitorElement = document.getElementById('visitor-count');

    if (visitorElement) {
      visitorElement.textContent = randomVisitorCount;
    }
  }

  updateVisitorCount();
  setInterval(updateVisitorCount, 20000);

});

// document.addEventListener("DOMContentLoaded", function() {
//     var customerInfoElements = document.querySelectorAll('.customer-info');
//     function updateCustomer() {
//       if (customerInfoElements.length > 0) {
//         var currentIndex = parseInt(localStorage.getItem('currentCustomerIndex')) || 0;
//         if (currentIndex >= customerInfoElements.length) {
//           currentIndex = 0;
//         }

//         var currentCustomer = customerInfoElements[currentIndex];
//         var customerName = currentCustomer.querySelector('.customer-name').innerText;
//         var customerOrderProduct = currentCustomer.querySelector('.customer-details p:first-child').innerText;
//         var customerLocation = currentCustomer.querySelector('.customer-details p:last-child').innerText;

//        document.getElementById('customer-display').innerHTML = `
//   <div class="customer_name_main">
//     <span class="customer_name">${customerName} from ${customerLocation}. Just completed a purchase for ${customerOrderProduct} Hats</span>
//   </div>
// `;
//         currentIndex = (currentIndex + 1) % customerInfoElements.length;
//         localStorage.setItem('currentCustomerIndex', currentIndex);
//       } else {
//         document.getElementById('customer-display').innerHTML = 'No valid customer information available.';
//       }
//     }
//     updateCustomer();
//     setInterval(updateCustomer, 20000);
//   });



document.addEventListener("DOMContentLoaded", function () {

  var customerInfoElements = document.querySelectorAll('.customer-info');
  var customerDisplay = document.getElementById('customer-display');

  function updateCustomer() {

    if (!customerDisplay) return;

    if (customerInfoElements.length > 0) {

      var currentIndex = parseInt(localStorage.getItem('currentCustomerIndex')) || 0;

      if (currentIndex >= customerInfoElements.length) {
        currentIndex = 0;
      }

      var currentCustomer = customerInfoElements[currentIndex];

      var customerName = currentCustomer.querySelector('.customer-name')?.innerText || '';
      var customerOrderProduct = currentCustomer.querySelector('.customer-details p:first-child')?.innerText || '';
      var customerLocation = currentCustomer.querySelector('.customer-details p:last-child')?.innerText || '';

      customerDisplay.innerHTML = `
        <div class="customer_name_main">
          <span class="customer_name">
            ${customerName} from ${customerLocation}. Just completed a purchase for ${customerOrderProduct} Hats
          </span>
        </div>
      `;

      currentIndex = (currentIndex + 1) % customerInfoElements.length;
      localStorage.setItem('currentCustomerIndex', currentIndex);

    } else {

      customerDisplay.innerHTML = 'No valid customer information available.';

    }
  }

  updateCustomer();
  setInterval(updateCustomer, 20000);

});

$(document).ready(function () {
    $(".featured-product-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: false,
    infinite: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
        },
      },
    ],
  });
  $(".logo-block-slider").slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    dots: false,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
        },
      },
    ],
  });
  $(".product-arrival-slider").slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<i class="fa-solid fa-angle-left icon-cls"></i>',
    nextArrow: '<i class="fa-solid fa-angle-right icon-cls"></i>',
    dots: false,
    autoplay: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  });
  $(".cap-testimonial").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    centerMode: true,
    focusOnSelect: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
        },
      },
    ],
  });

  $(".our-box-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
        },
      },
    ],
  });

  // Function to update the overlay image
  function updateOverlayImage(index) {
    var slideIndex = index; // Assuming index starts at 0 and you want the 5th image initially
    var currentImage = $(
      '.product-arrival-slider .slick-slide[data-slick-index="' +
        slideIndex +
        '"] img'
    ).attr("src");
    if (currentImage) {
      $("#overlay-image").attr("src", currentImage);
    }
  }

  // Update overlay image on initial load
  updateOverlayImage(0);

  // Event listener for slide change
  $(".product-arrival-slider").on(
    "afterChange",
    function (event, slick, currentSlide) {
      updateOverlayImage(currentSlide);
    }
  );

  // CSS to position the overlay image
  $("<style>")
    .prop("type", "text/css")
    .html(
      "\
        .overlay-image {\
          position: absolute;\
          top: 0;\
          left: 0;\
          width: 100%;\
          height: auto;\
          z-index: 10;\
        }\
        .product-new-arrival-image {\
          position: relative;\
        }\
      "
    )
    .appendTo("head");
});



document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".quantity-controls").forEach(function (wrapper) {
    const minusBtn = wrapper.querySelector(".qty-minus");
    const plusBtn = wrapper.querySelector(".qty-plus");
    const input = wrapper.querySelector(".quantity-selector");

    minusBtn.addEventListener("click", function () {
      let value = parseInt(input.value) || 1;
      if (value > 1) {
        input.value = value - 1;
      }
    });

    plusBtn.addEventListener("click", function () {
      let value = parseInt(input.value) || 1;
      input.value = value + 1;
    });
  });
});